(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-aries-language-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        try { localStorage.setItem('aries-language-chosen', event.submitter?.value || document.documentElement.lang); } catch (_) {}
      });
    });
    const dialog = root.querySelector('[data-aries-language-dialog]');
    if (dialog && !dialog.dataset.ready) {
      dialog.dataset.ready = 'true';
      const close = () => { try { localStorage.setItem('aries-language-chosen', document.documentElement.lang); } catch (_) {} dialog.close(); };
      dialog.querySelector('[data-aries-close]')?.addEventListener('click', close);
      dialog.addEventListener('cancel', close);
      let chosen = false;
      try { chosen = !!localStorage.getItem('aries-language-chosen'); } catch (_) {}
      const localizedVisit = document.documentElement.lang.startsWith('fr');
      if (!chosen && !localizedVisit && !window.Shopify?.designMode && typeof dialog.showModal === 'function') dialog.showModal();
      if (localizedVisit) { try { localStorage.setItem('aries-language-chosen', 'fr'); } catch (_) {} }
    }
    root.querySelectorAll('[data-aries-project-form]').forEach(form => {
      if (form.dataset.ready || form.querySelector('[data-form-success]')) return;
      form.dataset.ready = 'true';
      const steps = Array.from(form.querySelectorAll('[data-aries-step]'));
      const back = form.querySelector('[data-aries-back]');
      const next = form.querySelector('[data-aries-next]');
      const send = form.querySelector('[data-aries-send]');
      const progress = form.querySelector('[data-aries-progress]');
      if (!steps.length || !back || !next || !send || !progress) return;
      let active = 0;
      const show = (focus = true) => {
        steps.forEach((step, index) => step.hidden = index !== active);
        back.hidden = active === 0;
        next.hidden = active === steps.length - 1;
        send.hidden = active !== steps.length - 1;
        progress.textContent = `${progress.dataset.label} ${active + 1} / ${steps.length}`;
        if (focus) steps[active].querySelector('legend')?.focus();
      };
      const valid = step => {
        const invalid = Array.from(step.querySelectorAll('input,select,textarea')).find(input => !input.checkValidity());
        if (invalid) { invalid.reportValidity(); return false; }
        return true;
      };
      next.addEventListener('click', () => { if (valid(steps[active])) { active++; show(); } });
      back.addEventListener('click', () => { active--; show(); });
      form.addEventListener('submit', event => {
        const invalidStep = steps.findIndex(step => !Array.from(step.querySelectorAll('input,select,textarea')).every(input => input.checkValidity()));
        if (invalidStep !== -1) { event.preventDefault(); active = invalidStep; show(false); valid(steps[active]); }
      });
      form.classList.add('aries-form--guided');
      form.noValidate = true;
      show(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
